<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <v-dialog
    v-model="isShowDialog"
    width="400"
    scrollable
    @click:outside="cancel"
  >
    <v-card
      class="py-4"
      :height="'100%'"
    >
      <v-card-text>
        <!-- eslint-disable vue/v-on-event-hyphenation -->
        <order-card
          v-for="(vendingHistoryTemp, vendingHistoryTempIdx) in vendingHistoriesTemp"
          :key="`vendingHistoriesTemp[${vendingHistoryTempIdx}]`"
          v-model="vendingHistoryTemp.value"
          :vendibles="vendibles"
          :users="users"
          :size="vendingHistoryTemp.size"
          :removable="false"
          class="mb-4"
          :hide-persistence-report="!isCourseVendingHistory(vendingHistoryTemp.value)"
          @update:vendibleId="vendingHistoryTemp.value.vendibleId = $event"
          @update:vendibleType="vendingHistoryTemp.value.vendibleType = $event"
          @update:isNonExistVendible="vendingHistoryTemp.value.isNonExistVendible = $event"
          @update:vendibleName="vendingHistoryTemp.value.vendibleName = $event"
          @update:sellingPrice="vendingHistoryTemp.value.sellingPrice = $event"
          @update:taxCharge="vendingHistoryTemp.value.taxCharge = $event"
          @update:vendingContributionsAttributes="vendingHistoryTemp.value.vendingContributionsAttributes = $event"
          @update:isArbitraryVendingContribution="vendingHistoryTemp.isArbitraryVendingContribution = $event"
          @update:vendibleRecipientsAttributes="vendingHistoryTemp.value.vendibleRecipientsAttributes = $event"
          @update:vendingHistoryCustomersAttributes="vendingHistoryTemp.value.vendingHistoryCustomersAttributes = $event"
          @update:size="vendingHistoryTemp.size = $event"
          @update:isPaidInAdvance="vendingHistoryTemp.value.isPaidInAdvance = $event"
          @update:freeBack="vendingHistoryTemp.value.freeBack = $event"
          @remove="removeVendingHistoryTempByIndex(vendingHistoryTempIdx)"
        />

        <v-card
          elevation="0"
          class="d-flex flex-column align-center justify-center"
        >
          <v-text-field
            :value="`¥${currentTotal.toLocaleString()}`"
            readonly
            hide-details
            disabled
            class="right-input font-weight-bold px-2 pb-4 w-full"
          >
            <template #prepend-inner>
              <span class="text-sm">
                現在の合計支払額
              </span>
            </template>
          </v-text-field>

          <total-display
            :subtotal="estimatedSubtotal"
            :discount-fee="discountFee"
            :processing-fee="processingFee"
            :total="orderTotal"
            :title="'注文後'"
            :tax="estimatedTax"
            :subtotal-msg="'小計（合計）'"
            :tax-msg="'税サ等（合計）'"
            :total-msg="'合計支払額'"
            class="mb-4 px-2"
          />

          <div class="w-full d-flex justify-space-around align-center px-5">
            <confirm-required-button
              :is-confirmed="isShow ? isConfirmed.updateVendingHistories : true"
              :is-valid="isValidToSubmit"
              :is-submitting="isSubmitting"
              :btn-message="'注文確定'"
              :cancelable="true"
              :already-confirmed="!isShow"
              @confirmed="isConfirmed.updateVendingHistories = $event"
              @cancel="cancel"
              @clicked="isShow ? updateVendingHistories() : createVendingHistories()"
            />
          </div>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVModel } from '@vueuse/core'
import { mdiPlus } from '@mdi/js'
import OrderCard from '@/views/components/table/OrderCard/OrderCard.vue'
import ConfirmRequiredButton from '@/views/components/util/ConfirmRequiredButton.vue'
import TotalDisplay from '@/views/components/util/TotalDisplay.vue'

export default {
  name: 'OrderDialog',
  components: {
    OrderCard,
    ConfirmRequiredButton,
    TotalDisplay,
  },
  props: {
    isOrdering: {
      type: Boolean,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      required: true,
    },
    isValidToSubmit: {
      type: Boolean,
      required: true,
    },
    isConfirmed: {
      type: Object,
      required: true,
    },
    vendingHistoriesTemp: {
      type: Array,
      required: true,
    },
    vendibles: {
      type: Array,
      required: true,
      default: () => [
        {
          attributes: {},
        },

      ],
    },
    users: {
      type: Array,
      default: () => [],
    },
    currentTotal: {
      type: [Number, String],
      default: 0,
    },
    orderTotal: {
      type: Number,
      default: 0,
    },
    estimatedSubtotal: {
      type: Number,
      default: 0,
    },
    estimatedTax: {
      type: Number,
      default: 0,
    },
    discountFee: {
      type: Number,
      default: 0,
    },
    processingFee: {
      type: Number,
      default: 0,
    },
    vendingHistories: {
      type: Array,
      default: () => [],
    },
    persistenceReport: {
      type: Object,
      default: () => {},
    },
  },
  emits: [
    'update:isOrdering',
    'update:isConfirmed',
    'removeVendingHistoryTempByIndex',
    'updateVendingHistories',
    'createVendingHistories',
  ],
  setup(props, { emit }) {
    const isShowDialog = useVModel(props, 'isOrdering', emit)
    const isCourseVendingHistory = vendingHistory => {
      return vendingHistory.vendibleType === 'Course'
    }

    const removeVendingHistoryTempByIndex = index => {
      emit('removeVendingHistoryTempByIndex', index)
    }

    const updateVendingHistories = () => {
      emit('update-vending-histories')
    }

    const createVendingHistories = () => {
      emit('create-vending-histories')
    }

    const cancel = () => {
      emit('cancel')
    }

    return {
      isShowDialog,
      isCourseVendingHistory,
      removeVendingHistoryTempByIndex,
      updateVendingHistories,
      createVendingHistories,
      cancel,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>
